// ConEd/ORU match redirect_uri byte-for-byte against the URI registered with them,
// which is also what the backend token exchange sends (HOSTNAME in prod/dev settings).
// Both registered URIs sit on the old hosts; those hosts must 301 page loads to the new ones.
const PROD_HOSTS = ["app.getcarbonclear.com", "app.getcodeclear.com"];

export type UtilityEnv = "prod" | "dev";

export const utilityEnv = (): UtilityEnv =>
  PROD_HOSTS.includes(window.location.hostname) ? "prod" : "dev";

export const UTILITY_REDIRECT_URI: Record<UtilityEnv, string> = {
  prod: "https://app.getcarbonclear.com/external/auth_success",
  dev: "https://dev.app.getcarbonclear.com/external/auth_success",
};
